<template>
  <b-row>

    <!-- Fitlros -->
    <b-col cols="12" clas>
      <div v-b-toggle.collapse-data
        class="mt-3 shadow-sm px-4 py-2 pointer rounded w-100 w-full bg-gray-100 p-3 d-flex justify-content-between align-items-center"
        :class="visibleCollapseFIlters ? null : 'collapsed'" :aria-expanded="visibleCollapseFIlters ? 'true' : 'false'"
        aria-controls="collapse-data" @click="visibleCollapseFIlters = !visibleCollapseFIlters">
        <div>
          <i class="fa fa-filter" />
          <strong class="ml-2">{{ visibleCollapseFIlters ? 'Ocultar filtros' : 'Ver filtros' }}</strong>
        </div>
        <i :class="`fa ${!visibleCollapseFIlters ? 'fa-chevron-down' : 'fa-chevron-up'}`" />
      </div>
      <b-collapse id="collapse-1" v-model="visibleCollapseFIlters" class="my-4">
        <b-card class="shadow-sm border-none">

          <b-row>

            <!-- Inputs filter -->
            <b-col sm="12" md="9">

              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="nombre"><b>Nombre</b></label>
                    <b-form-input name="nombre" type="text" v-model="filtro.nombre" />
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="sinonimo"><b>Sinonimo</b></label>
                    <b-form-input id="sinonimo" name="sinonimo" type="text" v-model="filtro.sinonimos">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="id_fabricante">Fabricante</label>
                    <br />
                    <el-select id="id_fabricante" name="id_fabricante" v-model="filtro.id_fabricante" filterable
                      clearable no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
                      remote :remote-method="obtenerFabricantes">
                      <el-option v-for="fabricante in fabricantes" :key="fabricante.id" :label="fabricante.nombre"
                        :value="fabricante.id" />
                    </el-select>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                  <b-form-group>
                    <label for="fecha"><b>Fecha</b></label>
                    <br />
                    <el-date-picker v-model="filtro.confecha" id="range_date" name="range_date" type="daterange"
                      range-separator="a" value-format="yyyy-MM-dd" format="yyyy-MM-dd" start-placeholder="Fecha inicio"
                      end-placeholder="Fecha fin" class="w-100">
                    </el-date-picker>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                  <b-form-group>
                    <label for="bases"><b>Ubicaciones</b></label>
                    <br />
                    <treeselect :value="val" :multiple="true" :defaultExpandLevel="Infinity" :options="arbolUbicaciones"
                      value-consists-of="ALL_WITH_INDETERMINATE" @input="setFiltroUbicacion" placeholder="Buscar..."
                      :searchable="true" :show-count="true" :normalizer="normalizer" />
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                  <label for="bases">Estado</label>
                  <el-select v-model="filtro.estado" size="sm" class="form-contol">
                    <el-option v-for="estado in estados" :value="estado.text" :label="estado.text" :key="estado.id"
                      :style="'background:' + estado.color + '; color: black;'" />
                  </el-select>
                </b-col>
                <b-col sm="12" md="6">
                  <b-form-group>
                    <label for="tipo">Tipo</label>
                    <el-select v-model="filtro.tipo" clearable :rows="3" :max-rows="6" name="type" id="type">
                      <el-option v-for="language in getAvailableTypes" :key="language.value" :label="language.text"
                        :value="language.value">
                      </el-option>
                    </el-select>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                  <b-form-group>
                    <label for="campos">Disponible en el inventario</label>
                    <el-select v-model="filtro.in_use" clearable size="sm" class="form-contol"
                      @change="buscador(filtro, filtro.in_use)">
                      <el-option v-for="(in_use, index) in inUse" :value="in_use.value" :label="in_use.label"
                        :key="index" />
                    </el-select>
                  </b-form-group>
                </b-col>
              </b-row>

            </b-col>

            <!-- Checkbox filter -->
            <b-col sm="12" md="3">
              <b-row class="productos-faltantes-rpq rounded-full pt-2 pb-4 bg-gray-100">
                <b-col cols="12" class="mt-3">
                  <b-form-checkbox id="sinAsignar" name="sinVerificarAsignarPagar" v-model="filtro.sinAsignar"
                    @change="cleanCheckbox($event)" class="border-check"> Sin asignar
                  </b-form-checkbox>
                </b-col>
                <b-col cols="12">
                  <b-form-checkbox id="sinPagar" name="sinVerificarAsignarPagar" v-model="filtro.sinPagar"
                    @change="cleanCheckbox($event)" class="border-check">Sin caracterizar
                  </b-form-checkbox>
                </b-col>
                <b-col cols="12">
                  <b-form-checkbox id="sinTE" v-model="filtro.sinTE" @change="cleanCheckbox($event)"
                    class="border-check">Sin TE
                  </b-form-checkbox>
                </b-col>
                <b-col cols="12">
                  <b-checkbox id="selectorMultiple" name="selectorMultiple" class="float-left border-check"
                    v-model="filtro.selectorMultiple" @change="metodoSeleccion">
                    Selección múltiple
                  </b-checkbox>
                </b-col>
                <b-col cols="12">
                  <b-checkbox id="te_gen" name="te_gen" class="float-left border-check" v-model="filtro.te_gen">
                    TE Generadas
                  </b-checkbox>
                </b-col>
                <b-col cols="12">
                  <b-checkbox id="te_adj" name="te_adj" class="float-left border-check" v-model="filtro.te_adj">
                    TE Adjuntas
                  </b-checkbox>
                </b-col>
              </b-row>
            </b-col>

            <!-- Botones filter -->
            <b-col cols="12" class="mt-2">
              <b-button class="mx-1" variant="primary" @click.prevent="getProductsIndexRpq">
                <i class="fa fa-search fa-lg"></i> Buscar
              </b-button>
              <b-button class="mx-1" @click.prevent="limpiar()">
                <i class="fa fa-eraser fa-lg"></i> Limpiar
              </b-button>
            </b-col>

          </b-row>

        </b-card>
      </b-collapse>
    </b-col>

    <!-- Tabla historico -->
    <b-col sm="12">

      <div class="content-btns justify-content-end align-items-center pt-1">
        <!-- Comentarios de productos -->
        <el-tooltip v-if="canSeeActionToComments" effect="dark" placement="top"
          content="Agregar comentario general." popper-class="py-1 px-2">
          <b-button variant="primary" @click="onHandleCommentProducts()">
            <i class="fa fa-commenting-o fa-lg text-white"></i>
          </b-button>
        </el-tooltip>

        <!-- Opciones de uso/desuso -->
        <b-dropdown v-if="validarPermisoComponente('empresa-editar-rpq')" id="id-options-uses" text="Opciones de Disponibilidad en el inventario" class="content-btns-btn m-md-2 sm:m-0mx-1 sm:w-full sm:w-100 md:w-auto" variant="primary">
          <b-dropdown-item @click.prevent="onHandleChangeUse(true)">Marcar como disponible en el inventario</b-dropdown-item>
          <b-dropdown-item @click.prevent="onHandleChangeUse(false)">Marcar como no disponible en el inventario</b-dropdown-item>
        </b-dropdown>

        <!-- Asignaciones de ubicaciones -->
        <b-button v-if="products_ids.length && validarPermisoComponente('empresa-editar-rpq')" class="content-btns-btn float-xl-right sm:m-0 mr-2 sm:w-full sm:w-100 md:w-auto" variant="primary"
          @click="openModalChooseLocations()">
          <i class="fa fa-map-marker fa-lg"></i> Asignar ubicaciones
        </b-button>

        <!-- Resumen de productos -->
        <b-button v-if="validarPermisoComponente('empresa-editar-rpq')" @click.prevent="mostrarModal()" class="content-btns-btn float-xl-right sm:m-0 md:mx-2 sm:w-full sm:w-100 md:w-auto" variant="primary">
          <i class="fa fa-list fa-lg"></i> Resumen
        </b-button>

        <!-- Procesar productos seleccionados -->
        <b-button v-if="filtro.selectorMultiple" @click="guardarProductosMasivo"
          class="content-btns-btn float-xl-right sm:m-0 mx-2 my-md-0 sm:w-full sm:w-100 md:w-auto" variant="primary">
          <i class="fa fa-floppy-o" /> Procesar seleccionados
        </b-button>
      </div>

      <b-table class="b-table-asigns-m" style="font-size: 10pt;" responsive striped hover :items="productos.data"
        :fields="columnas" :tbody-tr-class="unClass" thead-tr-class="table-active" show-empty
        empty-text="No hay productos para mostrar">
        <template v-if="validarPermisoComponente('empresa-editar-rpq')" v-slot:cell(nombre)="data">
          <div class="d-flex">
            <b-form-checkbox @change="addProductIdToLocations(data.item)" :id="data.item.id" :name="data.item.id"
              :checked="products_ids.includes(data.item.id) ? true : false">
            </b-form-checkbox>
            <p>{{ data.item.nombre }} </p>
          </div>
        </template>

        <template v-if="validarPermisoComponente('asignar-rpq-masivo')" v-slot:head(asignado)="data">
          AsiRpq
          <b-button block size="sm" variant="warning" style="padding: 0" class="mt-1" v-b-tooltip.hover
            title="Marcar todos los productos como ASIGNADO RPQ" @click="asignarTodosLosProductos('asignado')">
            <i class="fa fa-check-square-o" />
          </b-button>
        </template>

        <template v-slot:head(pago)="data">
          Carac
          <b-button v-if="validarPermisoComponente('pagos-rpq-masivo')" block size="sm" variant="warning" style="padding: 0" class="mt-1" v-b-tooltip.hover
            title="Marcar todos los productos como PAGO" @click="asignarTodosLosProductos('pago')">
            <i class="fa fa-check-square-o" />
          </b-button>
        </template>

        <template v-slot:cell(sgaData)="data">
          <span v-if="data.item.sga.length > 0">SI</span>
          <span v-else>NO</span>
        </template>
        <template v-slot:cell(nfpaData)="data">
          <span v-if="data.item.nfpa != null">SI</span>
          <span v-else>NO</span>
        </template>
        <template v-slot:cell(hmisData)="data">
          <span v-if="data.item.hmisData != 'NO'">SI</span>
          <span v-else>NO</span>
        </template>
        <template v-slot:cell(unData)="data">
          <span v-if="data.item.u_n != null">SI</span>
          <span v-else>NO</span>
        </template>
        <template v-slot:cell(asignado)="data">
            <!-- @change="asigna(data.item.id, 'asignado', data.item.asignado)" -->
          <b-form-checkbox :id="'asignado' + data.item.id"
            @change="assignToRPQ(data.item)"
            :disabled="assignedDisabled(!!data.item.pago)"
            v-model="data.item.asignado" :name="'asignado' + data.item.id" value="1" unchecked-value="0" />
        </template>
        <template v-slot:cell(pago)="data">
            <!-- @change="asigna(data.item.id, 'pago', data.item.pago)" -->
          <b-form-checkbox :id="'pago' + data.item.id"
            @change="changeToCharacterized(data.item)"
            :disabled="paymentDisabled(data.item.asignado, !data.item.pago)" v-model="data.item.pago" :name="'pago' + data.item.id"
            value="1" unchecked-value="0" />
        </template>

        <!-- En uso/no-uso el producto -->
        <template v-slot:cell(in_use)="data">
          <b-form-checkbox
            v-if="(typeof data.item.empresa_asignada === 'object' && 'in_use' in data.item.empresa_asignada)"
            :id="'in_use' + data.item.id" @change="changeUse(data.item)" :name="'in_use' + data.item.id"
            v-model="data.item.empresa_asignada.in_use" value="1" unchecked-value="0" :disabled="!validarPermisoComponente('empresa-editar-rpq')" />
        </template>

        <template v-slot:cell(te)="data">
          <div class="display:flex">
            <b-form-checkbox v-if="data.item.tarjeta_emergencia_empresa != null" :id="'te' + data.item.id" disabled
              @change="
                      asigna(
                        data.item.id,
                        'te',
                        data.item.tarjeta_emergencia_empresa.estado
                      )
                      " v-model="data.item.tarjeta_emergencia_empresa.estado" :name="'te' + data.item.id" value="1"
              unchecked-value="0">
              <!-- Cuando la TE se encuentra desactualizada -->
              <i v-if="data.item.tarjeta_emergencia_empresa.estado == 2" v-b-tooltip.hover
                title="La información se encuentra desactualizada"
                class="fa fa-exclamation-triangle warning-ico-te"></i>
            </b-form-checkbox>
          </div>
        </template>
        <template v-slot:cell(te_adj)="data">
          <div class="display:flex" @click.prevent="showModalnactiveTeAdj(data.item.te_adj.empresas_adjuntos)">
            <b-form-checkbox v-if="data.item.te_adj && data.item.te_adj.empresas_adjuntos && data.item.te_adj.empresas_adjuntos.activo"
              v-model="data.item.te_adj.empresas_adjuntos.activo" :name="'te_adj' + data.item.id" value="1"
              unchecked-value="0" :disabled="!validarPermisoComponente('empresa-editar-rpq')">
            </b-form-checkbox>
          </div>
        </template>


        <template v-slot:cell(notes)="data">
          <el-tooltip v-if="canSeeActionToComments" effect="dark" placement="top"
            content="Ver comentarios del producto." popper-class="py-1 px-2">
            <b-button variant="primary" size="sm"
              @click="onHandleShowModalToSeeDetails(data.item, data.item.empresa_asignada.id || '')">
              <i class="fa fa-commenting-o fa-lg text-white"></i>
            </b-button>
          </el-tooltip>
        </template>


      </b-table>
    </b-col>

    <!-- Footer -->
    <b-col>

      <!-- Boton de volver -->
      <b-button @click="backRoute()" size="sm" variant="secondary" class="float-left">
        <i class="fa fa-reply fa-lg"></i>
        Volver
      </b-button>

      <!-- Paginación -->
      <el-pagination v-if="productos.data && !!productos.data.length" v-model="filtro.page" @size-change="getProductsIndexRpq"
        @current-change="getProductsIndexRpq" :current-page.sync="filtro.page" class="float-right"
        :page-size.sync="filtro.perPage" :page-sizes="[10, 30, 50, 100]" layout="total, sizes, prev, pager, next"
        :total="productos.total" />
    </b-col>

    <!-- Modal resumen -->
    <b-modal v-model="modal_resumen" title="Resumen" hide-footer centered>
      <resumen />
    </b-modal>

    <!-- Fragmentos -->
    <modalTraceablePQComponent ref="modalTraceablePQComponentRef" :confirmAssigned="confirmActionTraceablePQ"
      :loading="loading" />

    <!-- Modal detalles -->
    <modalDetailsTraceablePQHistoryComponent :canCreateNotes="true" />

    <!-- Modal asignar ubicaciones -->
    <ModalAssignLocationProducts ref="modalAssignLocationProductsRef" @resetProductsIds="resetProductsIds"
      :products_ids="products_ids" />

    <!-- Modal para controlde trazavilidad de multiples productos al tiempo -->
    <ModalTraceableMultiplePQsComponent ref="modalTraceableMultiplePQsComponentRef"
      :actionOK="onHandleActionOKMultiplePQs" :actionCancel="onHandleActionCancelMultiplePQs"
      :payload="payloadActionMultiplPQs" />

    <!-- Modal para agregar comentarios generales a los productos -->
    <ModalGeneralCommentsPQsComponent ref="modalGeneralCommentsPQsComponentRef"
      :confirmAction="onHandleActionOKGeneralCommentsPQs" :actionCancel="onHandleActionCancelGeneralComments"
      :payload="payloadGeneralComments" />

  </b-row>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import Swal from "sweetalert2";
import Resumen from "./Resumen";
import ModalAssignLocationProducts from "./ModalAssignLocationProducts";

// Componentes
import modalTraceablePQComponent from '../../productos/asignacion/fragments/ModalTraceablePQ.vue'
import modalDetailsTraceablePQHistoryComponent from '../../history/assignPQ/fragments/ModalTraceablePQHistory.vue'
import ModalTraceableMultiplePQsComponent from '../../productos/asignacion/fragments/ModalTraceableMultiplePQs.vue'
import ModalGeneralCommentsPQsComponent from '../../productos/asignacion/fragments/ModalGeneralCommentsPQs.vue'

// Helpers
import { validarPermisoComponente } from '@/plugins/acl';

export default {
  name: "buscador-productos",
  components: {
    Treeselect,
    Resumen,
    modalTraceablePQComponent,
    modalDetailsTraceablePQHistoryComponent,
    ModalAssignLocationProducts,
    ModalTraceableMultiplePQsComponent,
    ModalGeneralCommentsPQsComponent
  },
  data() {
    return {
      modal_resumen: false,
      mostrar: false,
      columnas: [
        {
          key: "nombre",
          label: "Nombre",
          sortable: true,
          thStyle: { "min-width": "200px !important" },
          thClass: "align-middle text-uppercase",
        },
        {
          key: "sinonimos",
          label: "Sinónimos",
          sortable: true,
          thStyle: { "min-width": "120px !important" },
          thClass: "align-middle text-uppercase",
        },
        {
          key: "fabricante.nombre",
          label: "Fabricante",
          sortable: true,
          thStyle: {
            "min-width": "150px !important",
            width: "150px !important",
          },
          thClass: "align-middle text-uppercase",
        },
        {
          key: "sgaData",
          label: "SGA",
          sortable: true,
          thStyle: { "max-width": "70px !important", width: "70px !important" },
          thClass: "text-center text-nowrap align-middle text-uppercase",
          tdClass: "text-center",
        },
        {
          key: "nfpaData",
          label: "NFPA",
          sortable: true,
          thStyle: { "max-width": "70px !important", width: "70px !important" },
          thClass: "text-center text-nowrap align-middle text-uppercase",
          tdClass: "text-center",
        },
        {
          key: "hmisData",
          label: "HMIS",
          sortable: true,
          thStyle: { "max-width": "70px !important", width: "70px !important" },
          thClass: "text-center text-nowrap align-middle text-uppercase",
          tdClass: "text-center",
        },
        {
          key: "unData",
          label: "UN",
          sortable: true,
          thStyle: { "max-width": "70px !important", width: "70px !important" },
          thClass: "text-center text-nowrap align-middle text-uppercase",
          tdClass: "text-center",
        },
        {
          key: "asignado",
          label: "AsiRpq",
          sortable: true,
          thStyle: { "max-width": "80px !important", width: "80px !important" },
          thClass: "text-center text-nowrap align-middle text-uppercase",
          tdClass: "text-center",
        },
        {
          key: "pago",
          label: "Pago",
          sortable: true,
          thStyle: { "max-width": "80px !important", width: "80px !important" },
          thClass: "text-center text-nowrap align-middle text-uppercase",
          tdClass: "text-center",
        },
        {
          key: "in_use",
          label: "Disponible en el inventario",
          sortable: true,
          thStyle: { "max-width": "155px !important", width: "155px !important" },
          thClass: "text-center align-middle text-uppercase",
          tdClass: "text-center",
        },
        {
          key: "te",
          label: "TE gen",
          sortable: true,
          thStyle: { "max-width": "80px !important", width: "80px !important" },
          thClass: "text-center text-nowrap align-middle text-uppercase",
          tdClass: "text-center",
        },
        {
          key: "te_adj",
          label: "TE adj",
          sortable: true,
          thStyle: { "max-width": "80px !important", width: "80px !important" },
          thClass: "text-center text-nowrap align-middle text-uppercase",
          tdClass: "text-center",
        }
      ],
      rangeYear: ["", ""],
      status: "",
      loading: true,
      val: null,
      previoSinVerificar: false,
      previoSinAsignar: false,
      previoSinPagar: false,
      previoSinTE: false,
      previoBloqueado: false,
      products_ids: [],
      payloadActionMultiplPQs: null,
      payloadGeneralComments: null,
      inUse: [
        {
          value: 1,
          label: 'SI'
        },
        {
          value: 0,
          label: 'NO'
        }
      ],
      visibleCollapseFIlters: false,
      validarPermisoComponente: validarPermisoComponente,
    };
  },
  mounted() {
    if (validarPermisoComponente('acciones-comentarios-productos')) {
      this.columnas.push({
        key: "notes",
        label: "Comentarios",
        thClass: "text-center text-nowrap align-middle text-uppercase"
      });
    }
  },

  methods: {
    normalizer(node) {
      return {
        children: node.children && node.children.length ? node.children : 0,
      };
    },
    openModalChooseLocations() {

      if (this.$refs.modalAssignLocationProductsRef) {
        this.$refs.modalAssignLocationProductsRef.payload = {
          "locations": [],
          "products_ids": []
        }
        this.$refs.modalAssignLocationProductsRef.selecionadosIds = []
        this.$refs.modalAssignLocationProductsRef.initialSelection = []
      }

      this.$bvModal.show("modal_assign_locations_to_products")
    },
    async mostrarModal() {
      await this.getProductSummaryCompleted(this.$route.params.id);
      await this.cantidadSumaRpq(this.$route.params.id);
      this.modal_resumen = true;
    },
    async metodoSeleccion(e) {
      if (!e) {
        if (this.validarRpqMasivo()) {
          await Swal.fire({
            title: "Guardar cambios",
            text: "¿Desea guardar los cambios seleccionados?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si",
            cancelButtonText: "No",
          }).then(async (result) => {
            if (result.value) {
              await this.guardarProductosMasivo();
            } else {
              this.loading = true;
              await this.getProductsIndexRpq();
              await this.getProductSumByStatus(this.$route.params.id);
              this.limpiarRpqMasivoProductos();
              this.loading = false;
            }
          });
        }
      }
    },
    validarRpqMasivo() {
      const rpq_masivo = this.rpqMasivoProductos;

      return (
        !!rpq_masivo.verificado.length ||
        !!rpq_masivo.asignado.length ||
        !!rpq_masivo.pago.length ||
        !!rpq_masivo.te.length
      );
    },
    async guardarProductosMasivo() {
      this.loading = true;
      await this.guardarProductosMasivoRpq();
      await this.getProductsIndexRpq();
      await this.getProductSumByStatus(this.$route.params.id);
      this.loading = false;
    },
    cleanCheckbox(e) {
      if (this.previoSinVerificar == true) {
        this.filtro.sinVerificar = false;
      } else if (this.previoSinAsignar == true) {
        this.filtro.sinAsignar = false;
      } else if (this.previoSinPagar == true) {
        this.filtro.sinPagar = false;
      } else if (this.previoSinTE == true) {
        // Se añade filtro de sin tarjeta de emergencia
        this.filtro.sinTE = false;
      } else if (this.previoBloqueado == true) {
        this.filtro.bloqueado = false;
      }

            this.previoSinVerificar = this.filtro.sinVerificar;
            this.previoSinAsignar = this.filtro.sinAsignar;
            this.previoSinPagar = this.filtro.sinPagar;
            this.previoSinTE = this.filtro.sinTE;
            this.previoBloqueado = this.filtro.bloqueado;
    },
        async limpiar() {
            this.setLoading(false);
            this.asignaEmpresa(this.$route.params.id);
            this.resetFiltro();
            await this.getProductsIndexRpq();
        },
        unClass(item) {
            if (!item) return;
            if (!item.sga || !item.u_n) return 'table-danger';
            if (item.bloqueo == 1) return 'table-success';
            if (item.bloqueo == 0) return 'table-warning';
        },
        ...mapActions('empresa', [
            'getDiligenciados',
            'cantidadSumaRpq',
            'getProductSumByStatus',
            'getProductSummaryCompleted'
        ]),
        ...mapActions('productos_emp', [
            'getProductsIndexRpq',
            'getProductosEmpresa',
            'getEmpresaFiltro',
            'getBasesFiltro',
            'getAreasFiltro',
            'descargarAdjunto',
            'getCamposPersonalizados',
            'getProductoTarjeta',
            'setPagePagination',
            'guardaRpqProducto',
            'guardarProductosMasivoRpq',
            'obtenerFabricantes',
            'asignarTodosLosProductos'
        ]),
        async changeToCharacterized(product){
            const payload = {
                id: product.id,
                type: 'pago',
                status: product.pago
            };
            this.loading = false;
            this.setActionToTraceablePQ({
                action: 'CHARACTERIZED',
                data: payload
            });
            this.$bvModal.show('modalTraceablePQComponent')
        },
        async assignToRPQ(product){
            const payload = {
                id: product.id,
                type: 'asignado',
                status: product.asignado
            };
            this.loading = false;
            this.setActionToTraceablePQ({
                action: 'ASSINED-RPQ',
                data: payload
            })
            this.$bvModal.show('modalTraceablePQComponent')
        },
    async changeUse(product) {
      try {


        this.setLoadingCancelProcess(false);
        this.setLoading(true);

        await this.getInfoAsignacion(product.id).then(async () => {

          if ('asignaciones' in this.selectedBuscaEmpr && this.selectedBuscaEmpr.asignaciones.length > 0) {

            this.selectedBuscaEmpr.asignaciones.map(async (asignation) => {
              if (asignation.id == this.selectedEmpresa.id) {

                const payload = {
                  product_id: product.id,
                  in_use: !asignation.in_use,
                  company_id: this.selectedEmpresa.id,
                };

                this.loading = false;
                this.setActionToTraceablePQ({
                  action: 'USE',
                  data: payload
                })
                this.$bvModal.show('modalTraceablePQComponent')

              }
            });

          }
        });

        this.setLoading(false);

      } catch (error) {
        Swal.fire({
          title: "Diligenciados",
          text: "Falla al tratar de intentar cambiar el estado del uso del diligenciado",
          icon: "warning",
          confirmButtonText: "Si"
        })
        await this.limpiar();
      }
    },
    /**
     * Se confirma la acción desde el modal y se procesa la acción necesaria.
     *
     * @param Boolean isSuccess
     * @param Object payload
     * @author Fernando Claros
     */
    async confirmActionTraceablePQ(isSuccess, payload) {

        if (!isSuccess) {
            this.loading = false;
            await this.limpiar();
            this.$bvModal.hide('modalTraceablePQComponent');
            this.setLoadingCancelProcess(false);
            return false;
        }
        const data = payload.data;
        const type = data.type;

        if(isSuccess && data.type != undefined && (data.type == 'pago' || data.type == 'asignado')) {
            this.synchronizeRPQProducts({id_producto: data.id, tipo: data.type, estado: data.status})
            .then(()=>this.$bvModal.hide('modalTraceablePQComponent'));
        } else {
            this.loading = true;
            await this.changeUseProductCompany({ ...payload.data, comments:this.traceable.comments, type: this.traceable.type })
            .then(async () => {
                this.$bvModal.hide('modalTraceablePQComponent');
                await this.limpiar()
            })
            .catch(async () => {
                this.$bvModal.hide('modalTraceablePQComponent');
                await this.limpiar()
            });
        }
    },
    /**
     * Abre el modal para mostrar los detalles del histórico, tipo Notas/Comentarios.
     *
     * @param {*} product
     * @param {*} assignId
     * @author Fernando Claros
     */
    async onHandleShowModalToSeeDetails(product, assignId) {
      this.setDataTraceable({
        assignId,
        company_id: this.selectedEmpresa.id,
        product_id: product.id,
        product: {
          ...product,
          company: this.selectedEmpresa
        }
      });

      this.$bvModal.show('modalTraceablePQHistoryComponent')
      await this.getTraceableByCompanyAndAssignId({
        load: 'ALL',
        assignId,
        company_id: this.selectedEmpresa.id,
        ...this.dataModalTraceable.table.data
      });
    },
    /**
     * Marcar los productos en uso o desuso.
     *
     * @param {boolean} action, true: todos en USO. false: Todos en DESUSO
     * @author Fernando Claros
     */
    onHandleChangeUse(action) {

      this.products_ids = this.productos.data.map(product => product.id);
      this.payloadActionMultiplPQs = { productIds: this.products_ids, action: action ? 1 : 0, companyId: this.selectedEmpresa.id };
      this.$bvModal.show('modalTraceableMultiplePQsComponent')

    },
    /**
     * Proceso de uso/desuso multiple confirmado.
     *
     * @param {boolean} action
     * @param {object} payload
     * @param {string|null} txtDescriptionProcess
     *
     * @author Fernando Claros
     */
    async onHandleActionOKMultiplePQs(payload) {
      await this.storeTraceableMultiple(payload).then(async () => {
        this.$refs.modalTraceableMultiplePQsComponentRef.onHandleCancel();
        await this.limpiar();
      });
    },
    /**
    * Proceso de uso/desuso multiple cancelado.
    *
    * @author Fernando Claros
    */
    onHandleActionCancelMultiplePQs() {

      this.payloadActionMultiplPQs = null
      this.products_ids = []
      this.$bvModal.hide('modalTraceableMultiplePQsComponent')

    },
    /**
    * Abrir modal para comentar los productos en masivo.
    *
    * @author Fernando Claros
    */
    onHandleCommentProducts() {

      this.products_ids = this.productos.data.map(product => product.id);
      this.payloadGeneralComments = {
        action: 2,
        productIds: this.products_ids,
        companyId: this.selectedEmpresa.id
      };
      this.$bvModal.show('modalGeneralCommentsPQsComponentId')

    },
    /**
    * Comentar los productos en masivo confirmado.
    *
    * @param Object payload - {comment, productsAction}
    *
    * @author Fernando Claros
    */
    async onHandleActionOKGeneralCommentsPQs(payload) {
      await this.storeGeneralComments({
        ...this.payloadGeneralComments,
        productIds: this.payloadGeneralComments.productIds,
        comments: payload.comment,
        productsAction: payload.productsAction,
        selectedProductsFilled: payload.selectedProductsFilled
      }).then(async () => {
        this.$refs.modalGeneralCommentsPQsComponentRef.onHandleCancel();
        await this.limpiar();
      });
    },
    /**
    * Comentar los productos en masivo, cerrar modal - cancelado.
    *
    * @author Fernando Claros
    */
    onHandleActionCancelGeneralComments() {
      this.payloadGeneralComments = null
      this.products_ids = []
      this.$bvModal.hide('modalGeneralCommentsPQsComponentId')

    },
        // Acciones del modulo de productos asignaciones
        ...mapActions("asignacionproductos", [
          "changeUseProductCompany",
          "getInfoAsignacion"
        ]),
        ...mapMutations('asignacionproductos', ['setLoadingCancelProcess']),
        ...mapMutations('productos_emp', [
            'setFiltro',
            'setFiltroBases',
            'setFiltroAreas',
            'limpiarProducto',
            'setPermisosAdmin',
            'setPermisosEmpresa',
            'resetFiltro',
            'resetProducts',
            'asignaEmpresa',
            'setFiltroUbicacion',
            'setRpqMasivoProductos',
            'limpiarRpqMasivoProductos'
        ]),
        // Estados para el modulo del Dashboard
        ...mapMutations('dashboard', {
          setLoading: 'load'
        }),
        // Mutaciones para el modulo: trazabilidad de asignaciones y usos
        ...mapMutations('assignPQTraceable', [
          'setDataTraceable',
          'setActionToTraceablePQ'
        ]),
        ...mapActions('empresa', ['getDiligenciados']),
        ...mapActions('adjuntos', ['assignCompanies', 'getTotalAttachmentsTECompany', 'getTipo']),
            // Acciones para el modulo: trazabilidad de asignaciones y usos
        ...mapActions('assignPQTraceable', [
          'getTraceableByCompanyAndAssignId',
          'storeTraceableMultiple',
          'storeGeneralComments'
        ]),
        async asigna(id, tipo, estado) {
            var dataCompact = {
                id_producto: id,
                tipo: tipo,
                estado: estado,
            };
            if (!this.filtro.selectorMultiple) {
                this.synchronizeRPQProducts(data);
            } else {
                this.setRpqMasivoProductos(dataCompact);
            }
        },
        async synchronizeRPQProducts(data) {
            const payload = { ...data, comments: this.traceable.comments, type: this.traceable.type };
            this.loading = true;
            await this.guardaRpqProducto(payload).then(async () => {
                await this.getTotalAttachmentsTECompany(this.$route.params.id)
            });
            await this.getProductsIndexRpq();
            await this.getProductSumByStatus(this.$route.params.id);
            this.loading = false;
        },
    async showModalnactiveTeAdj(data) {
      if(!this.validarPermisoComponente('empresa-editar-rpq')) return;
      Swal.fire({
        title: "Inactivar TE Adjunta",
        text: "¿Está seguro de inactivar la tarjeta de emergencia?",
        icon: "warning",
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        confirmButtonColor: "#32696e",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Inactivar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.onHandleAssignCompanies(data)
        }
      });
    },
    async onHandleAssignCompanies(data) {
      let payload = {
        id: data.id_adjunto,
        company: data.id_empresa
      }
      await this.assignCompanies(payload).then(async () => {
        await this.getTotalAttachmentsTECompany(this.$route.params.id);
        await this.getProductsIndexRpq();
      });
    },
    addProductIdToLocations({id}) {
      if (!this.products_ids.includes(id)) {
        this.products_ids.push(id)
      } else {
        const index = this.products_ids.findIndex(item => item == id);
        this.products_ids.splice(index, 1)
      }
    },
    async resetProductsIds(){
      this.products_ids = [];
    },
    assignedDisabled(pago) {
      return !this.validarPermisoComponente('empresa-editar-rpq') || pago;
    },
    paymentDisabled(asignado, pago) {
      return !this.validarPermisoComponente('empresa-editar-rpq') || !asignado;
    },
    backRoute(){
      const currentPath = this.$route.path;
      if (currentPath.includes("/my-company")) {
        this.$router.go(-1);
      }else {
        this.$router.push("/empresas");
      }
    }
    },
    beforeDestroy() {
        this.asignaEmpresa(this.$route.params.id);
        this.resetFiltro();
        this.resetProducts();
    },
    computed: {
      ...mapState('empresa', ['selectedEmpresa']),
      ...mapState('asignacionproductos', ['selectedBuscaEmpr']),
        ...mapState('productos_emp', [
            'productos',
            'filtro',
            'empresas',
            'selectedProduct',
            'bases',
            'areas',
            'campos',
            'esAdmin',
            'esEmpresa',
            'rpqMasivoProductos',
            'fabricantes',
            'estados',
        ]),
        ...mapState('productos', ['ubicEmpresa', 'arbolUbicaciones']),
      ...mapGetters('productos_emp', ['getParams']),
        // Estados del modulo: trazabilidad de asignaciones y usos
      ...mapState('assignPQTraceable', [
        'dataModalTraceable',
        'actionToTraceablePQ',
        'traceable'
      ]),
      ...mapState('adjuntos', ['tipos']),
      canSeeActionToComments() {
        return validarPermisoComponente('acciones-comentarios-productos');
      },
      canSeeActionToFilterAdjs() {
        return validarPermisoComponente('filtro-tipos-adjuntos');
      },
      getAvailableTypes() {
        return this.tipos.filter(x => (x.value !== 157 && x.value !== 177));
      }
    },
};
</script>

<style src="@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>

<style>
.border-none{
  border: none !important;
}
.pointer {
  cursor: pointer;
}
.border-check {
  border: 1.5px solid #cdcdcd;
  padding: 10px 32px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-bottom: 4px;
  border-radius: 10px;
}

.el-input__inner {
  height: 32px;
}

.productos-faltantes-rpq {
  display: flex;
  justify-content: space-between;
}

@media only screen and (max-width: 675px) and (min-width: 575px) {
  .productos-faltantes-rpq {
    min-width: 100%;
  }
}

@media (min-width: 0px) and (max-width: 500px) {
  .content-btns{
    display: block !important;
  }
  .content-btns-btn{
    width: 100% !important;
    margin: 2px 0px !important;
  }
}

.content-btns {
  display: flex;
}

.el-date-editor .el-range-separator {
  line-height: 25px;
  width: 10%;
}

.el-date-editor--monthrange.el-input,
.el-date-editor--monthrange.el-input__inner {
  width: 100%;
}

.warning-ico-te {
  font-size: 15px;
  margin-top: 4px;
}

@media only screen and (max-width: 1488px) {
  .b-table-asigns-m {
    max-width: 64vw;
  }
}

@media only screen and (max-width: 1484px) {
  .b-table-asigns-m {
    max-width: 63.9vw;
  }
}

@media only screen and (max-width: 1480px) {
  .b-table-asigns-m {
    max-width: 63.8vw;
  }
}

@media only screen and (max-width: 1475px) {
  .b-table-asigns-m {
    max-width: 63.7vw;
  }
}

@media only screen and (max-width: 1471px) {
  .b-table-asigns-m {
    width: 936.7px;
  }
}

@media only screen and (max-width: 1470px) {
  .b-table-asigns-m {
    width: 935.7px;
  }
}

@media only screen and (max-width: 1469px) {
  .b-table-asigns-m {
    width: 934.7px;
  }
}

@media only screen and (max-width: 1468px) {
  .b-table-asigns-m {
    width: 933.7px;
  }
}


@media only screen and (max-width: 1467px) {
  .b-table-asigns-m {
    width: 932.7px;
  }
}

@media only screen and (max-width: 1466px) {
  .b-table-asigns-m {
    width: 931.7px;
  }
}

@media only screen and (max-width: 1465px) {
  .b-table-asigns-m {
    max-width: 62vw;
  }
}

@media only screen and (max-width: 1433px) {
  .b-table-asigns-m {
    width: 100%;
    max-width: 100%;
  }
}

@media (min-width: 1433px) and (max-width: 1900px) {
  .tab-content {
    min-width: auto !important;
    overflow-x: auto;
  }
}


@media (min-width: 1901px) and (max-width: 1963px) {
  .tab-content {
    min-width: auto !important;
    overflow-x: auto;
  }
}

</style>
